import { Component } from '@angular/core';

@Component({
  selector: 'summary-text',
  template: `<div [innerHTML]="'authorize.summary' | translate"></div>`,
})
export class SummaryComponent {
  
}
